/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

export const OPTIONS_PERIODE_RECENSEMENT: Record<
  'key' | 'text' | 'value',
  number | string | number
>[] = [
  { key: 1, text: '1e trimestre', value: 1 },
  { key: 2, text: '2e trimestre', value: 2 },
  { key: 3, text: '3e trimestre', value: 3 },
  { key: 4, text: '4e trimestre', value: 4 },
];

export const OPTIONS_RECENSE: Record<
  'key' | 'text' | 'value',
  number | string | string
>[] = [
  {
    key: 1,
    text: 'des recensés',
    value: 'recenses',
  },
  {
    key: 2,
    text: 'des recensés régularisés',
    value: 'recenses-regularises',
  },
  {
    key: 3,
    text: 'des non recensés',
    value: 'non-recenses',
  },
];

export const OPTIONS_EXEMPTION = [
  {
    key: 1,
    text: "Grand infirme (titulaire d'une carte d'invalidité de 80% minimum)",
    value: 'invalide',
  },
  {
    key: 2,
    text: 'Affection ou maladie invalidante rendant inapte à participer',
    value: 'maladie',
  },
];
